export type ChoirRehearsalsGuideStepId = "create_rehearsal";

export interface ChoirRehearsalsGuideState {
    completed: ChoirRehearsalsGuideStepId[];
    dismissed_at: string | null;
    completed_at: string | null;
}

export const CHOIR_REHEARSALS_GUIDE_STEPS: ChoirRehearsalsGuideStepId[] = [
    "create_rehearsal",
];

export function createDefaultChoirRehearsalsGuideState(
    seed?: Partial<ChoirRehearsalsGuideState> | null
): ChoirRehearsalsGuideState {
    const completed = Array.isArray(seed?.completed)
        ? seed!.completed.filter((step): step is ChoirRehearsalsGuideStepId => CHOIR_REHEARSALS_GUIDE_STEPS.includes(step as ChoirRehearsalsGuideStepId))
        : [];

    return {
        completed,
        dismissed_at: seed?.dismissed_at ?? null,
        completed_at: seed?.completed_at ?? null,
    };
}

export function getChoirRehearsalsGuideNextStep(state: ChoirRehearsalsGuideState): ChoirRehearsalsGuideStepId | null {
    const completed = new Set(state.completed || []);
    return CHOIR_REHEARSALS_GUIDE_STEPS.find((step) => !completed.has(step)) || null;
}

export function isChoirRehearsalsGuideStepCompleted(
    state: ChoirRehearsalsGuideState,
    step: ChoirRehearsalsGuideStepId
): boolean {
    return state.completed.includes(step);
}

export function markChoirRehearsalsGuideStep(
    state: ChoirRehearsalsGuideState,
    step: ChoirRehearsalsGuideStepId
): ChoirRehearsalsGuideState {
    if (state.completed.includes(step)) {
        return state;
    }

    const nextCompleted = [...state.completed, step];
    const done = nextCompleted.length >= CHOIR_REHEARSALS_GUIDE_STEPS.length;
    return {
        ...state,
        completed: nextCompleted,
        completed_at: done ? state.completed_at || new Date().toISOString() : state.completed_at,
    };
}
